import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { AvatarModule as NgxAvatarModule } from 'ngx-avatar';
import { NgxAvatarFixDirective } from '../ngx-avatar-fix/ngx-avatar-fix.directive';
import { AvatarComponent } from './avatar.component';

export const NgxAvatarColors = [
  '#6E6BED',
  '#AC6BED',
  '#AD3B2B',
  '#AD5A2B',
  '#6B9FED',
  '#2BAD8E',
  '#6B9FED',
  '#9797FC',
  '#B1B1DA',
  '#6EE05C',
];

@NgModule({
  imports: [
    CommonModule,
    NgxAvatarModule.forRoot({
      colors: NgxAvatarColors,
    }),
  ],
  declarations: [NgxAvatarFixDirective, AvatarComponent],
  exports: [AvatarComponent],
})
export class AvatarModule {}
